import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import Skeleton from "@mui/material/Skeleton";
const words = [
  "Effortless",
  "Seamless",
  "Efficient",
  "Flawless",
  "Smart",
  "Precise",
  "Agile",
];
const HeroSection = () => {
  const [isBgLoading, setIsBgLoading] = useState(true);
  const [isImgLoading, setIsImgLoading] = useState(true);
  const [displayedText, setDisplayedText] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentWord = words[wordIndex];
    const typingSpeed = isDeleting ? 60 : 130;
    const pauseTime = 1000;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setDisplayedText(currentWord.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);

        if (charIndex + 1 === currentWord.length) {
          setTimeout(() => setIsDeleting(true), pauseTime);
        }
      } else {
        setDisplayedText(currentWord.substring(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);

        if (charIndex - 1 === 0) {
          setIsDeleting(false);
          setWordIndex((prev) => (prev + 1) % words.length); // loop to next word
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, wordIndex]);

  return (
    <div className="relative pt-36">
      {/* Background Image with Skeleton */}
      <div className="absolute inset-0 w-full h-full">
        {/* {isBgLoading && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            className="absolute inset-0"
          />
        )} */}
        <img
          src="/assests/images/LandingPage/Hero-section1.webp"
          alt="Background"
          onLoad={() => setIsBgLoading(false)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            isBgLoading ? "opacity-0" : "opacity-100"
          }`}
        />
      </div>

      {/* Hero Section Container */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        {/* Tagline */}
        <div className="flex justify-center flex-col items-center md:inline-block bg-gray-100 text-gray-800 text-sm font-medium pr-2 py-2 rounded-full mb-6 shadow-sm">
          <span className=" text-white bg-black rounded-full mb-2 px-4 py-2 font-semibold text-xs sm:text-lg ">
            What's New?
          </span>
          <span className="ml-2 text-xs sm:text-lg">
            Now Execute Your Retail Branding Campaigns Digitally
          </span>
        </div>

        {/* Heading */}
        <h1 className="text-5xl sm:text-5xl md:text-6xl lg:text-5xl xl:text-7xl font-bold text-gray-800 mb-8">
          World's first <br /> and only retail branding <br /> execution
          platform
          {/* <motion.span
            className="text-blue-600 ml-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {displayedText}
            <motion.span
              className="inline-block w-[2px] h-10 bg-blue-600 ml-1"
              animate={{ opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 1 }}
            />
          </motion.span> */}
        </h1>

        {/* Description */}
        <p className="text-gray-600 text-base sm:text-lg md:text-xl lg:text-2xl mb-8 max-w-4xl mx-auto">
          Powering On-Ground Retail Branding Execution with Technology
        </p>

        {/* Call-to-Action Button */}
        <Link
          to="/ContactUs"
          className="bg-blue-600 text-white py-3 px-6 text-sm sm:text-lg rounded-lg hover:bg-blue-700"
        >
          Book A Demo{" "}
        </Link>

        {/* Foreground Image with Skeleton */}
        <div className="xl:mx-20 my-20 relative w-fit mx-auto">
          {/* Skeleton Loader - Absolute over Image */}
          {/* {isImgLoading && (
            <Skeleton
              variant="rectangular"
              width={5724}
              height={3784}
              className="absolute top-0 left-0 w-full h-full"
            />
          )} */}

          {/* Image */}
          <img
            src="/assests/images/LandingPage/dashboardImg1.webp"
            alt="Dashboard Overview"
            onLoad={() => setIsImgLoading(false)}
            className={`w-full h-auto transition-opacity duration-500 ${
              isImgLoading ? "opacity-0" : "opacity-100"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
